<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    content-class="AcaoFluxo__menu"
    transition="scale-transition"
    offset-x
    left>
    <template v-slot:activator="{ on: menuFunction }">
      <v-list-item v-on="menuFunction" icon
        :color="corIcone"
        v-if="layoutGrid"
        class="AcaoFluxo__listItem">
        <v-list-item-action>
          <v-icon>{{ icone }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>{{ textoAcao }}</v-list-item-title>
      </v-list-item>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn v-on="{ ...tooltip, ...menuFunction }" icon :color="corIcone">
            <v-icon>{{ icone }}</v-icon>
          </v-btn>
        </template>
        <span>{{ textoAcao }}</span>
      </v-tooltip>
    </template>

      <v-card class="AcaoFluxo__card" outlined>

      <v-card-title class="AcaoFluxo__card-title">
        <h3 class="headline mb-0">{{ textoAcao }}</h3>
      </v-card-title>

        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text class="AcaoFluxo__card-text">
            <v-row dense class="AcaoFluxo__form-row">
              <v-col cols="12">
                <v-textarea
                  id="Acaofluxo_justificativa"
                  index="1"
                  ref="textareaJustificativa"
                  name="Acaofluxo_justificativa"
                  v-model="justificativa"
                  auto-grow
                  autofocus
                  rows="1"
                  :rules="[required]"
                  :disabled="bloquearCampos"
                  :label="validarJustificativa ? `${$t('label.justificativa')} *` : $t('label.justificativa')"
                  :counter="500"
                  maxlength="500">
                </v-textarea>
                <v-text-field
                  v-if="exigePoEvidencia"
                  v-model="numeroPedidoCompra"
                  :label="`${$t('label.numero_pedido_compra')} *`"
                  :rules="[rulesPo.required, rulesPo.alfanumerico]"
                  :disabled="bloquearCampos"
                ></v-text-field>
                <div v-if="exigePoEvidencia" class="AcaoFluxo__evidencias">
                  <v-file-input
                    :key="fileInputKey"
                    v-model="fileInputSelecao"
                    :label="labelAnexarEvidencias"
                    :rules="[rulesPo.evidenciasObrigatorias, rulesPo.evidenciasLimite]"
                    accept=".pdf,application/pdf"
                    multiple
                    show-size
                    prepend-icon="attach_file"
                    :disabled="bloquearCampos || arquivosEvidencia.length >= maxArquivosEvidencia"
                    clearable
                    @change="onEvidenciasSelecionadas"
                  ></v-file-input>
                  <div
                    v-if="arquivosEvidencia.length"
                    class="caption grey--text text--darken-1 mb-1">
                    {{ contadorEvidencias }}
                  </div>
                  <ul
                    v-if="arquivosEvidencia.length"
                    class="AcaoFluxo__lista-evidencias">
                    <li
                      v-for="(arquivo, indice) in arquivosEvidencia"
                      :key="chaveArquivoEvidencia(arquivo, indice)"
                      class="AcaoFluxo__item-evidencia">
                      <div class="AcaoFluxo__item-evidencia-texto">
                        <div class="AcaoFluxo__nome-arquivo">{{ arquivo.name }}</div>
                        <div class="caption grey--text">{{ formatarTamanhoArquivo(arquivo.size) }}</div>
                      </div>
                      <v-btn
                        icon
                        small
                        :disabled="bloquearCampos"
                        @click="removerEvidencia(indice)">
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="mostrarCamposDinamicos" dense>
              <v-col cols="12">
                <metadados-container-layout
                  :metadados-entidade="metadadosCampos"
                  :layout-class="layoutClass"
                  :input-layout="inputLayout"
                  :objeto="listaCamposDinamicos"
                  :somenteLeitura="!mostrarRodape"
                  ref="container">
                </metadados-container-layout>
              </v-col>
            </v-row>
            <v-row v-if="acaoProrrogacao" dense>
              <v-col cols="12">
                <metadados-campo-dinamico-data
                  :metadados="cfgCampoProrrogacao"
                  :somenteLeitura="false"
                  v-model="dtaProrrogacao"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>

      <v-divider v-if="mostrarRodape" />

      <v-card-actions
        v-if="mostrarRodape"
        class="AcaoFluxo__card-actions">
        <v-spacer></v-spacer>

          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn v-if="icone !== 'cancel'" icon v-on="on" @click="cancelar" :disabled="bloquearCampos">
                <v-icon>cancel</v-icon>
              </v-btn>
              <v-btn v-if="icone === 'cancel'" color="primary darken-1" text @click="cancelar" :disabled="bloquearCampos">Não</v-btn>
            </template>
            <span>{{ $t('label.cancelar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-if="icone !== 'cancel'" v-on="on" icon :color="corIcone" @click="executarAcao" :disabled="bloquearCampos">
                <v-icon>{{ icone }}</v-icon>
              </v-btn>
              <v-btn v-if="icone === 'cancel'" text color="primary darken-1" @click="executarAcao" :disabled="bloquearCampos">Sim</v-btn>
            </template>
            <span>{{ textoAcao }}</span>
          </v-tooltip>
        </v-card-actions>

    </v-card>

    <v-card v-if="exibirPerguntaProximo">
      <v-card-text>
        {{ $t('message.deseja_seguir_proxima_apuracao') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn @click="naoIrProximo" color="primary">
          {{ $t('label.nao') }}
        </v-btn>

        <v-btn @click="irProximo" color="accent">
          {{ $t('label.sim') }}
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import MetadadosContainerLayout from './metadados/MetadadosContainerLayout';
import MetadadosCampoDinamicoData from './metadados/campos-dinamicos/MetadadosCampoDinamicoData';

const TAMANHO_MAXIMO_BYTES = 15 * 1024 * 1024;
const MAX_ARQUIVOS_EVIDENCIA = 5;

export default {
  name: 'AcaoFluxo',
  props: {
    acao: {
      type: Object,
      default() {
        return {};
      },
    },
    configuracao: {
      type: Object,
      default: null,
    },
    corIcone: {
      type: String,
      default: null,
    },
    icone: {
      type: String,
      default: '',
    },
    disabled: false,
    status: {
      type: String,
      default: '',
    },
    perguntarProximo: {
      type: Boolean,
      default: false,
    },
    validarJustificativa: {
      type: Boolean,
      default: false,
    },
    textoAcao: {
      type: String,
      default: '',
    },
    mostrarRodape: {
      type: Boolean,
      default: true,
    },
    mostrarCamposDinamicos: {
      type: Boolean,
      default: false,
    },
    acaoProrrogacao: {
      type: Boolean,
      default: false,
    },
    observacaoAcao: {
      type: String,
      default: undefined,
    },
    layoutGrid: {
      type: Boolean,
      default: false,
    },
    exigePoEvidencia: {
      type: Boolean,
      default: false,
    },
    primeiroAprovador: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      valid: false,
      bloquearCampos: false,
      justificativa: '',
      numeroPedidoCompra: '',
      arquivosEvidencia: [],
      fileInputSelecao: null,
      fileInputKey: 0,
      maxArquivosEvidencia: MAX_ARQUIVOS_EVIDENCIA,
      dtaProrrogacao: null,
      rulesPo: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        alfanumerico: (value) => this.poAlfanumerico(value) || this.$t('message.formato_invalido_alfanumerico'),
        evidenciasObrigatorias: () => (this.arquivosEvidencia.length > 0)
          || this.$t('message.campo_obrigatorio'),
        evidenciasLimite: () => !this.arquivosEvidencia.length
          || this.evidenciasValidas(this.arquivosEvidencia)
          || this.$t('message.evidencia_limite_arquivos'),
      },
      exibirPerguntaProximo: false,
      metadados: null,
      layoutClass: {
        wrap: true,
      },
      inputLayout: {
        xs12: true,
        sm6: true,
        md12: true,
      },

      cfgCampoProrrogacao: {
        vlrObrigatorio: true,
        nomCampo: this.$t('label.data_prorrogacao'),
        desAtributos: {
          dtaMinima: 'amanha',
        },
      },
    };
  },
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => this.$refs.textareaJustificativa.focus(), 5E2);
        this.$emit('AcaoFluxo_menuAberto');
      } else {
        this.fechar();
      }
    },
  },
  components: {
    MetadadosContainerLayout,
    MetadadosCampoDinamicoData,
  },
  computed: {
    ...mapGetters('metadados', [
      'getAcaoMetadado',
    ]),
    labelAnexarEvidencias() {
      const base = this.$t('label.evidencias');
      return `${base} * (${this.$t('label.anexar')} — PDF, máx. ${MAX_ARQUIVOS_EVIDENCIA} × 15MB)`;
    },
    contadorEvidencias() {
      return `${this.arquivosEvidencia.length} / ${MAX_ARQUIVOS_EVIDENCIA}`;
    },
    listaCamposDinamicos() {
      const acaoEdicao = {};
      Object.assign(acaoEdicao, { num_pedido_cac: this.acao.numPedidoCac });
      Object.assign(acaoEdicao, { shipment_logistica: this.acao.shipmentLogistica });
      Object.assign(acaoEdicao, this.acao);
      if (this.acao && this.acao.passoGeral && this.acao.passoGeral.mapaCamposDinamicos) {
        Object.assign(acaoEdicao,
          {
            ...this.acao.passoGeral,
            ...this.acao.passoGeral.mapaExtensoes,
            ...this.acao.passoGeral.mapaCamposDinamicos,
          });
      }
      return acaoEdicao;
    },
    metadadosCampos() {
      if (this.getAcaoMetadado && this.getAcaoMetadado.mapaCamposDinamicos) {
        const metadados = { ...this.getAcaoMetadado };
        const resultado = {};
        const campos = metadados.mapaCamposDinamicos;
        if (this.configuracao && this.configuracao.passo3) {
          this.configuracao.passo3.listaDinamica.forEach((a) => {
            Object.keys(campos).forEach((key) => {
              if (this.isApuracaoValida() && key === a.label && a.indHabilitaAprovacaoApuracao) {
                resultado[key] = campos[key];

                if (a.indEdicaoApuracaoPrimeiroPasso && !this.primeiroAprovador) {
                  resultado[key].desAtributos.desabilitado = true;
                }
              }
              if (!this.isApuracaoValida() && key === a.label && a.indHabilitaAprovacaoPlanejamento) {
                resultado[key] = campos[key];
              }
            });
          });
        }
        metadados.mapaCamposDinamicos = resultado;
        metadados.mapaEntidades = {};
        metadados.dicionario = {};
        return metadados;
      }
      return undefined;
    },

  },
  methods: {
    preencheJustificativa(observacao) {
      this.bloquearCampos = true;
      this.justificativa = observacao;
    },
    required(v) {
      return !this.validarJustificativa || !!v || this.$t('label.campo_obrigatorio');
    },
    cancelar() {
      this.fechar();
    },
    fechar() {
      this.justificativa = '';
      this.numeroPedidoCompra = '';
      this.arquivosEvidencia = [];
      this.fileInputSelecao = null;
      this.fileInputKey += 1;
      this.dtaProrrogacao = null;
      this.menu = false;
      this.exibirPerguntaProximo = false;
      this.desbloquearCampos();
    },
    extraPoEvidencia() {
      if (!this.exigePoEvidencia) {
        return undefined;
      }
      return {
        numeroPedidoCompra: this.numeroPedidoCompra,
        arquivosEvidencia: this.arquivosEvidencia,
      };
    },
    poAlfanumerico(value) {
      if (!value) {
        return false;
      }
      return /[0-9A-Za-z]/.test(value);
    },
    chaveArquivoEvidencia(arquivo, indice) {
      if (!arquivo) {
        return indice;
      }
      return `${arquivo.name}-${arquivo.size}-${arquivo.lastModified || indice}`;
    },
    formatarTamanhoArquivo(bytes) {
      if (bytes == null || Number.isNaN(bytes)) {
        return '';
      }
      if (bytes < 1024) {
        return `${bytes} B`;
      }
      if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`;
      }
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    },
    evidenciaDuplicada(arquivo) {
      return this.arquivosEvidencia.some(
        (item) => item.name === arquivo.name
          && item.size === arquivo.size
          && item.lastModified === arquivo.lastModified,
      );
    },
    onEvidenciasSelecionadas(arquivos) {
      if (!arquivos || this.bloquearCampos) {
        return;
      }
      const lista = Array.isArray(arquivos) ? arquivos : [arquivos];
      lista.forEach((arquivo) => this.tentarAdicionarEvidencia(arquivo));
      this.fileInputSelecao = null;
      this.fileInputKey += 1;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },
    tentarAdicionarEvidencia(arquivo) {
      if (!arquivo) {
        return;
      }
      if (this.arquivosEvidencia.length >= MAX_ARQUIVOS_EVIDENCIA) {
        this.$toast(this.$t('message.evidencia_maximo_atingido'));
        return;
      }
      if (!this.arquivoPdfValido(arquivo)) {
        this.$toast(this.$t('message.evidencia_pdf_15mb'));
        return;
      }
      if (this.evidenciaDuplicada(arquivo)) {
        this.$toast(this.$t('message.evidencia_ja_anexada'));
        return;
      }
      this.arquivosEvidencia.push(arquivo);
    },
    removerEvidencia(indice) {
      this.arquivosEvidencia.splice(indice, 1);
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },
    evidenciasValidas(arquivos) {
      if (!arquivos || !arquivos.length) {
        return false;
      }
      if (arquivos.length > MAX_ARQUIVOS_EVIDENCIA) {
        return false;
      }
      return arquivos.every((arquivo) => this.arquivoPdfValido(arquivo));
    },
    arquivoPdfValido(arquivo) {
      if (!arquivo) {
        return false;
      }
      const nome = (arquivo.name || '').toLowerCase();
      const tipo = arquivo.type || '';
      const pdf = nome.endsWith('.pdf') || tipo === 'application/pdf';
      return pdf && arquivo.size <= TAMANHO_MAXIMO_BYTES;
    },
    naoIrProximo() {
      this.$emit('AcaoFluxo_executarAcao',
        this.justificativa,
        false,
        this.getValoresMetadados(),
        this.dtaProrrogacao,
        this.extraPoEvidencia());
      this.fechar();
    },
    irProximo() {
      this.$emit('AcaoFluxo_executarAcao',
        this.justificativa,
        true,
        this.getValoresMetadados(),
        this.dtaProrrogacao,
        this.extraPoEvidencia());
      this.fechar();
    },
    acaoExecutada() {
      this.exibirPerguntaProximo = true;
    },
    desbloquearCampos() {
      this.bloquearCampos = false;
    },
    executarAcao() {
      if (!this.$refs.form.validate()) return;
      this.bloquearCampos = true;
      if (this.perguntarProximo) {
        this.acaoExecutada();
      } else {
        this.naoIrProximo();
      }
    },
    getStatus(status) {
      return {
        APROVADO: this.$tc('status_entidade.aprovado', 1),
        AGUARDANDO_APROVACAO: this.$tc('status_entidade.aprovado', 1),
        EM_ANALISE: this.$tc('status_entidade.em_analise', 1),
        REPROVADO: this.$tc('status_entidade.reprovado', 1),
      }[status];
    },
    getValoresMetadados() {
      if (this.mostrarCamposDinamicos) {
        return { ...this.$refs.container.getValoresCamposDinamicos() };
      }
      return undefined;
    },
    preencherJustificativa() {
      if (this.observacaoAcao) {
        this.justificativa = this.observacaoAcao;
      }
    },
    isApuracaoValida() {
      return this.acao && this.acao.idApuracao;
    },
  },
  beforeMount() {
    this.preencherJustificativa();
  },
};
</script>
<style scoped>
.AcaoFluxo__card {
  width: 500px;
  max-width: calc(100vw - 32px);
  background: #fff;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14),
    0 9px 46px 8px rgba(0, 0, 0, 0.12);
}
.AcaoFluxo__card-title {
  padding-bottom: 8px;
}
.AcaoFluxo__card-text {
  padding-top: 0;
}
.AcaoFluxo__form-row {
  margin-left: 0;
  margin-right: 0;
}
.AcaoFluxo__form-row >>> .col {
  padding-left: 0;
  padding-right: 0;
}
.AcaoFluxo__card-actions {
  padding: 8px 12px 12px;
}
.AcaoFluxo__evidencias {
  width: 100%;
}
.AcaoFluxo__lista-evidencias {
  list-style: none;
  margin: 0 0 8px;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
.AcaoFluxo__item-evidencia {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 8px 8px 12px;
}
.AcaoFluxo__item-evidencia + .AcaoFluxo__item-evidencia {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.AcaoFluxo__item-evidencia-texto {
  flex: 1;
  min-width: 0;
}
.AcaoFluxo__nome-arquivo {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
  font-size: 14px;
}
</style>
<style>
/* v-menu transparente; contorno fica só no v-card */
.AcaoFluxo__menu.theme--light,
.AcaoFluxo__menu.theme--dark {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
  overflow: visible;
  contain: none;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  z-index: 200;
}
</style>
